import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Placeholder } from "rsuite";
import { PopularProducts, PopularPackages } from "../../services/reports.sevices";

const ReportCharts = ({ filter, From }) => {
    const [productReportData, setProductReportData] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(true);

    const [packageGraph, setPackageGraph] = useState([]);
    const [packageStats, setPackageStats] = useState({ total_collected: 0, total_pending: 0 });
    const [loadingPackages, setLoadingPackages] = useState(true);


    // ------------------------ Filter Data ------------------------
    const filterData = (data) => {
        const today = new Date();
        let startDate = new Date("2000-01-01");

        if (filter === "7d") startDate = new Date(today.setDate(today.getDate() - 7));
        if (filter === "30d") startDate = new Date(today.setDate(today.getDate() - 30));
        if (filter === "90d") startDate = new Date(today.setDate(today.getDate() - 90));

        return data.filter((d) => new Date(d.date) >= startDate);
    };
        // products and packages
    useEffect(() => {
        if (From === "ProductReport" || !From) {
            setLoadingProducts(true);

            PopularProducts(filter)
                .then((res) => {
                    setProductReportData(res.data || []);
                    setTimeout(() => {
                        setLoadingProducts(false);
                    }, 1000);
                })
                .catch((err) => {
                    console.log("error ====> ", err);
                    setLoadingProducts(false);
                });
        }
        
        if (From === "PackageReport") {
             setLoadingPackages(true);
             PopularPackages(filter)
                .then((res) => {
                    if(res.data && res.data.graph) {
                        setPackageGraph(res.data.graph);
                        setPackageStats(res.data.stats || { total_collected: 0, total_pending: 0 });
                    }
                    setTimeout(() => {
                        setLoadingPackages(false);
                    }, 1000);
                })
                .catch((err) => {
                    console.log("error ====> ", err);
                    setLoadingPackages(false);
                });
        }
    }, [From, filter]);
    const productSeries = [
  {
    name: "Revenue",
    data:
      productReportData && productReportData.length > 0
        ? productReportData.map((p) => p.total_revenue)
        : [],
  },
];

const productOptions = {
  chart: {
    type: "bar",
    toolbar: { show: false },
  },

  plotOptions: {
    bar: {
      horizontal: true,
      borderRadius: 6,
      barHeight: "60%",
    },
  },

  dataLabels: {
    enabled: true,
    formatter: (val) => `Rs.${val}`,
  },

  xaxis: {
    categories:
      productReportData && productReportData.length > 0
        ? productReportData.map((p) => p.product_name)
        : [],   // empty categories
    title: {
      text: "Revenue",
    },
  },

  colors: ["var(--admin_primary_color)"],

  grid: {
    borderColor: "#f1f1f1",
    strokeDashArray: 4,
  },

  tooltip: {
    y: {
      formatter: (val) => `Rs.${val}`,
    },
  },
};

const packageDates = [...new Set(packageGraph.map(g => g._id && g._id.date ? g._id.date : 'N/A'))].sort();
const hoursData = packageDates.map(d => {
  const item = packageGraph.find(g => (g._id && g._id.date) === d && (g._id && g._id.type) === 'Hours');
  return item ? item.total_revenue : 0;
});
const aiClicksData = packageDates.map(d => {
  const item = packageGraph.find(g => (g._id && g._id.date) === d && (g._id && g._id.type) === 'AiClicks');
  return item ? item.total_revenue : 0;
});

const packageSeries = [
  { name: "Hours Packages Revenue", data: hoursData },
  { name: "Ai Clicks Packages Revenue", data: aiClicksData }
];

const packageOptions = {
  chart: {
    type: "bar",
    toolbar: { show: false },
    stacked: true,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 6,
      columnWidth: "60%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: packageDates,
    title: { text: "Date" },
  },
  colors: ["#5e5fb9", "#f53c7a"],
  grid: {
    borderColor: "#f1f1f1",
    strokeDashArray: 4,
  },
  tooltip: {
    y: {
      formatter: (val) => `Rs.${val}`,
    },
  },
};

    // ------------------------ Render ------------------------
    return (
        <div>
            {/* Product Report Chart */}
            {!From || From === "ProductReport" ? (
                <div
                    className="flex-1 rounded-2xl bg-white p-4 shadow-sm mb-3"
                    style={{ borderRadius: "11px" }}
                >
                    <h2 className="main-content-label">Top Selling Products</h2>

                    {!loadingProducts ? (
                        <>
                            {productReportData && productReportData.length > 0 ? (
                                <Chart
                                    options={productOptions}
                                    series={productSeries}
                                    type="bar"
                                    height={400}
                                />
                            ) : (
                                <div className="text-center p-4">No records found</div>
                            )}
                        </>
                    ) : (
                        <Placeholder.Paragraph
                            className="w-100 admin-placeholder"
                            rowHeight={430}
                            rowSpacing={5}
                            active
                            rows={1}
                        />
                    )}
                </div>
            ) : null}

            {/* Package Report Chart */}
            {From === "PackageReport" ? (
                <div
                    className="flex-1 rounded-2xl bg-white p-4 shadow-sm mb-3"
                    style={{ borderRadius: "11px" }}
                >
                    <div className="d-flex justify-content-between align-items-center mb-3">
                       <h2 className="main-content-label">Package Purchases Revenue</h2>
                       <div className="d-flex gap-4">
                          <div className="text-end">
                            <span className="text-muted d-block" style={{fontSize: '12px'}}>Total Collected</span>
                            <strong className="text-success fs-5">Rs. {packageStats.total_collected || 0}</strong>
                          </div>
                          <div className="text-end">
                            <span className="text-muted d-block" style={{fontSize: '12px'}}>Total Pending</span>
                            <strong className="text-warning fs-5">Rs. {packageStats.total_pending || 0}</strong>
                          </div>
                       </div>
                    </div>

                    {!loadingPackages ? (
                        <>
                            {packageGraph && packageGraph.length > 0 ? (
                                <Chart
                                    options={packageOptions}
                                    series={packageSeries}
                                    type="bar"
                                    height={400}
                                />
                            ) : (
                                <div className="text-center p-4">No records found</div>
                            )}
                        </>
                    ) : (
                        <Placeholder.Paragraph
                            className="w-100 admin-placeholder"
                            rowHeight={430}
                            rowSpacing={5}
                            active
                            rows={1}
                        />
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default ReportCharts;
